import styled, { css } from 'styled-components/macro';

interface FileDropZoneContainerProps {
  dragActive?: boolean;
  disabled?: boolean;
}

export const FileDropZoneContainer = styled.div<FileDropZoneContainerProps>`
  background-color: ${({ theme }) => theme.colors.white[100]};
  border: 1px dashed ${({ theme }) => theme.colors.neutral[40]};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 400px;
  border-radius: 5px;
  transition:
    border 0.2s ease,
    background-color 0.2s ease,
    opacity 0.2s ease;
  cursor: pointer;
  text-align: center;

  ${({ dragActive, theme }) =>
    dragActive &&
    css`
      border-color: ${theme.colors.primary[60]};
      background-color: ${theme.colors.primary[5]};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const FileInfoContainer = styled.div`
  margin-top: 10px;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral[80]};
`;

export const PreviewImage = styled.img`
  margin-top: 20px;
  max-width: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const PreviewAudio = styled.audio`
  margin-top: 20px;
  width: 100%;
  max-width: 300px;
`;
